
import { GET_NATIONALITIES } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  getNationalities,
  getNationalitiesPending,
  getNationalitiesFulfilled,
  getNationalitiesRejected,
} = createAsyncActions(GET_NATIONALITIES, 'getNationalities');


// WEBPACK FOOTER //
// ./src/actions/getNationalitiesActions.js